import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { userApiEvents } from 'modules/api/user'

/** How often an open, visible tab tells the user service it is still in use. */
const HEARTBEAT_MS = 60_000

/**
 * While signed in, beat once a minute but only when the tab is visible, and straight away when
 * it becomes visible again, so a backgrounded tab drops off the who-is-online list.
 */
const useSessionHeartbeat = (isAuthenticated: boolean): void => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (!isAuthenticated) return undefined

    const beat = () => {
      if (document.visibilityState === 'visible') dispatch(userApiEvents.heartbeat_request())
    }

    beat()
    const timer = window.setInterval(beat, HEARTBEAT_MS)
    document.addEventListener('visibilitychange', beat)
    return () => {
      window.clearInterval(timer)
      document.removeEventListener('visibilitychange', beat)
    }
  }, [isAuthenticated, dispatch])
}

export default useSessionHeartbeat
